import Button from '@material-ui/core/Button';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';
export const StyledButton = styled(Button)`
  && {
    color: rgba(0, 0, 0, 0.69);
    font-family: 'OpenSans-Regular';
    font-size: 13px;
    letter-spacing: 0;
    text-align: left;
    text-transform: capitalize;
    background-color: #fff;
    border: none;
  }
`;
export const StyledMainDiv = styled.div`
  && {
    height: 415px;
    overflow-y: auto;
    overflow-x: hidden;
  }
`;
export const HeadingEntityCards = styled(Typography)`
  && {
    color: rgba(0, 0, 0, 0.85) !important;
    font-family: 'OpenSans-Regular !important';
    font-size: 14px !important;
    font-weight: 500 !important;
    letter-spacing: 0 !important;
    line-height: 45px !important;
  }
`;